import React from 'react'

function ValidationAdminHeader() {
   return (
    <nav className="navbar navbar-light bg-light">
      <div className="container-fluid">
        <a className="navbar-brand" href="#">
          <img src="/images/gtoken-logo.jpg" alt="" width="30" height="24" className="d-inline-block align-text-top" />
          <div className='ms-3 float-end'>Global Inc</div>
        </a>
      </div>
    </nav>
  )
}

export default ValidationAdminHeader